/* global google */
export default class GroundOverlayCreator{
    constructor(markers, image, map, opacity, rotation, editMode){
        
        this.bounds_ = new google.maps.LatLngBounds(markers[0].getPosition(), markers[1].getPosition());
        this.markers = markers;
        this.image_ = image;
        this.opacity_ = opacity;
        this.rotation_ = rotation;
        this.div_ = null;
        this.setMap(map);
        this.editMode_ = editMode;

    }
}
GroundOverlayCreator.prototype = new google.maps.OverlayView();
GroundOverlayCreator.prototype.getOpacity = function() {
    return this.opacity_;
}

GroundOverlayCreator.prototype.getBounds = function() {
    return this.bounds_;
}

GroundOverlayCreator.prototype.setOpacity = function(opacity) {
    this.opacity_ = opacity;
}

GroundOverlayCreator.prototype.getRotation = function() {
    return this.rotation_;
}

GroundOverlayCreator.prototype.setRotation = function(opacity) {
    this.rotation_ = opacity;
}


GroundOverlayCreator.prototype.onAdd = function() {

    var container = document.createElement('div');
    var that = this;

    container.draggable = true;
    container.style.borderStyle = 'none';
    container.style.borderWidth = '0px';
    container.style.position = 'absolute';
    container.style.opacity = this.opacity_;

    var img = document.createElement('img');
    img.src = this.image_;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.position = 'relative';
    container.appendChild(img);
    that.div_ = container;
    /*
    google.maps.event.addDomListener(this.get('map').getDiv(),
            'mouseleave',
            function() {
                google.maps.event.trigger(container, 'mouseup');
            }
    );

    google.maps.event.addDomListener(container,
            'mousedown',
            function(e) {
                this.style.cursor = 'move';
                that.getMap().set('draggable', false);
                that.set('origin', e);

                that.moveHandler = google.maps.event.addDomListener(that.get('map').getDiv(),
                        'mousemove',
                        function(e) {

                            var origin = that.get('origin'),
                                    left = origin.clientX - e.clientX,
                                    top = origin.clientY - e.clientY,
                                    posSW = that.getProjection()
                                    .fromLatLngToDivPixel(that.getBounds().getSouthWest()),
                                    posNE = that.getProjection()
                                    .fromLatLngToDivPixel(that.getBounds().getNorthEast()),
                                    latLngSW = that.getProjection()
                                    .fromDivPixelToLatLng(new google.maps.Point(posSW.x - left,
                                            posSW.y - top)),
                                    latLngNE = that.getProjection()
                                    .fromDivPixelToLatLng(new google.maps.Point(posNE.x - left,
                                            posNE.y - top));
                            that.set('origin', e);
                            if (markers.length > 1) {
                                that.bounds_ = new google.maps.LatLngBounds(latLngSW, latLngNE);
                                markers[0].setPosition(latLngSW);
                                markers[1].setPosition(latLngNE);
                                that.draw();
                            }
                        });
            }
    );
    

    google.maps.event.addDomListener(container, 'mouseup', function() {
        that.getMap().set('draggable', true);
        this.style.cursor = 'default';
        google.maps.event.removeListener(that.moveHandler);
    });

    google.maps.event.addDomListener(container, 'mouseover', function() {
        this.style.cursor = 'move';
    });
    */

    if (this.editMode_) {
        this.set('container', container);
        this.getPanes().floatPane.appendChild(container);
    } else {
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(container);
    }

};


GroundOverlayCreator.prototype.draw = function() {
    var overlayProjection = this.getProjection();
    var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
    var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());
    var div = this.div_;

    var width = (ne.x - sw.x);
    var height = (sw.y - ne.y);
    if (width <= 0 || height <= 0) {

        var top = sw.y;
        var left = ne.x;
        width = (sw.x - left);
        height = (ne.y - top);

        if (height <= 0) {
            top = ne.y;
            height = (sw.y - top);
        }

        if (width <= 0) {
            left = sw.x;
            width = (ne.x - left);
        }

        div.style.left = left + 'px';
        div.style.top = top + 'px';
        div.style.width = width + 'px';
        div.style.height = height + 'px';

    } else {

        div.style.left = sw.x + 'px';
        div.style.top = ne.y + 'px';
        div.style.width = width + 'px';
        div.style.height = height + 'px';
    }
    div.style.opacity = this.opacity_;
    div.style.webkitTransform = 'rotate(' + this.rotation_ + 'deg)';
    div.style.mozTransform = 'rotate(' + this.rotation_ + 'deg)';
    div.style.msTransform = 'rotate(' + this.rotation_ + 'deg)';
    div.style.oTransform = 'rotate(' + this.rotation_ + 'deg)';
    div.style.transform = 'rotate(' + this.rotation_ + 'deg)';

};
/*

GroundOverlayCreator.prototype.updateBounds = function(marker) {
    if (null === markers || typeof (markers) === "undefined" || typeof (marker) !== "object") {
        return;
    }
    this.bounds_ = new google.maps.LatLngBounds(markers[0].getPosition(), markers[1].getPosition());
    this.draw(marker);
};
*/

GroundOverlayCreator.prototype.onRemove = function() {
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
};